import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http.get('/assets/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      })
      .catch(error => {
        console.error('Could not load configuration:', error);
        // Set a fallback value to prevent errors
        this.config = { baseUrl: 'https://default-api-url.com' };
      });
  }

  get baseUrl(): string {
    return this.config.baseUrl || 'https://default-api-url.com';
  }
}